// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Bezier Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'Bezier Sans', sans-serif;
}

.form-container {
  padding-right: 20%;
  padding-left: 20%;
  width: 100%;
  max-width: 762px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
}

.horizontal-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.label {
  font-family: 'Bezier Sans';
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 5px;
}

.label-error {
  color: #0080ff; /* Blue color for empty required fields */
}

.phone-input-container {
  width: 356.4px;
}

.phone-input-container .react-tel-input {
  width: 100%;
}

.phone-input-container input {
  font-family: 'Bezier Sans';
  height: 43.2px;
  border: 1px solid black;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 0;
}

.text-window {
  border-radius: 15px;
  font-family: 'Bezier Sans';
  width: 100%;
  height: 44.8px;
  resize: none;
  border: 1px solid black;
  font-size: 16px;
  line-height: 1.5;
}

.email-window {
  width: 356.4px;
  height: 43.2px;
}

.message-window {
  height: 100px;
}

.necessary-note {
  font-family: 'Bezier Sans';
  font-weight: normal;
  font-size: 12px;
  color: #0080ff;
  margin-top: 5px;
}

.input-phone {
  font-family: 'Bezier Sans';
  width: 100%;
  height: 48.2px;
  border: 1px solid black;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 15px;
}

.contact-button {
  width: 622px;
  height: 38px;
  background-color: #0080ff;
  border-radius: 15px;
  border: 1px solid #0014ff;
  font-family: 'Bezier Sans';
  font-size: 16px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  margin: 20px auto 0; /* Center horizontally and add top margin */
  transition: background-color 0.3s, color 0.3s;
  align-self: center; /* Center within flex container */
}

.contact-button:hover {
  background-color: #ffffff;
  color: black;
}

.data-admin-note {
  font-family: 'Bezier Sans';
  font-size: 12px;
  color: #0080ff;
  margin-top: 20px;
  text-align: center;
  width: 100%; /* Ensure it takes full width */
  display: flex;
  justify-content: center; /* Center horizontally */
  padding-bottom: 20%;
}

.feedback {
  color: #0014ff;
  justify-content: center;
  align-self: center;
}

.horizontal-container .input-container:first-child {
  margin-right: 20px; /* Adjust the value as needed */
}

.error {
  border-color: red; /* Цвет границы для полей с ошибками */
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}



/* Mobile styles */
@media (max-width: 768px) {
  .form-container {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .label {
    padding-right: 10px;
    padding-left: 10px;
  }

  .horizontal-container {
    flex-direction: column; /* Stack vertically on mobile */
    align-items: flex-start; /* Align items to the start */
  }

  .input-container {
    width: 100%; /* Full width for input containers */
    padding: 0;
    margin-bottom: 15px; /* Add more spacing between inputs */
  }

  .text-window,
  .email-window,
  .input-phone {
    margin-left: 10px;
    width: 85%; /* Ensure phone input is the same width as other inputs */
    height: 48px; /* Increase height for better touch experience */
  }

  .phone-input-container {
    width: 100%; /* Ensure full width for the container */
  }

  .phone-input-container input {
    height: 48px; /* Match the height of other inputs */
  }

  .contact-button {
    width: 80%; /* Full width for the button */
    height: 48px; /* Increase button height */
  }

  .message-window {
    height: 150px; /* Increased height for mobile */
  }

  .data-admin-note {
    align-items: center;
    width: 80%;
    padding-left: 5%;
    padding-bottom: 150px; /* Increase padding for better spacing */
  }

  .elementstyle {
    width: 80%;
  }

  .input-phone {
    margin-left: 10px;
    width: 85%; 
     /* Ensure full width inside the reduced container */
  }
  .necessary-note {
    padding-left: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/contactus/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;;iEAEgE;EAChE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,yCAAyC;AAC3D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB,EAAE,2CAA2C;EAChE,6CAA6C;EAC7C,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAE,+BAA+B;EAC5C,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;AACrD;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;;;AAIA,kBAAkB;AAClB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB,EAAE,+BAA+B;IACvD,uBAAuB,EAAE,6BAA6B;EACxD;;EAEA;IACE,WAAW,EAAE,oCAAoC;IACjD,UAAU;IACV,mBAAmB,EAAE,oCAAoC;EAC3D;;EAEA;;;IAGE,iBAAiB;IACjB,UAAU,EAAE,yDAAyD;IACrE,YAAY,EAAE,gDAAgD;EAChE;;EAEA;IACE,WAAW,EAAE,wCAAwC;EACvD;;EAEA;IACE,YAAY,EAAE,qCAAqC;EACrD;;EAEA;IACE,UAAU,EAAE,8BAA8B;IAC1C,YAAY,EAAE,2BAA2B;EAC3C;;EAEA;IACE,aAAa,EAAE,gCAAgC;EACjD;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,qBAAqB,EAAE,wCAAwC;EACjE;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,UAAU;KACT,mDAAmD;EACtD;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@font-face {\r\n  font-family: 'Bezier Sans';\r\n  src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n       url('../../public/fonts/BezierSans.woff') format('woff'),\r\n       url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\nbody {\r\n  font-family: 'Bezier Sans', sans-serif;\r\n}\r\n\r\n.form-container {\r\n  padding-right: 20%;\r\n  padding-left: 20%;\r\n  width: 100%;\r\n  max-width: 762px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.input-container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.horizontal-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.label {\r\n  font-family: 'Bezier Sans';\r\n  font-weight: normal;\r\n  font-size: 12px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.label-error {\r\n  color: #0080ff; /* Blue color for empty required fields */\r\n}\r\n\r\n.phone-input-container {\r\n  width: 356.4px;\r\n}\r\n\r\n.phone-input-container .react-tel-input {\r\n  width: 100%;\r\n}\r\n\r\n.phone-input-container input {\r\n  font-family: 'Bezier Sans';\r\n  height: 43.2px;\r\n  border: 1px solid black;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n}\r\n\r\n.text-window {\r\n  border-radius: 15px;\r\n  font-family: 'Bezier Sans';\r\n  width: 100%;\r\n  height: 44.8px;\r\n  resize: none;\r\n  border: 1px solid black;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.email-window {\r\n  width: 356.4px;\r\n  height: 43.2px;\r\n}\r\n\r\n.message-window {\r\n  height: 100px;\r\n}\r\n\r\n.necessary-note {\r\n  font-family: 'Bezier Sans';\r\n  font-weight: normal;\r\n  font-size: 12px;\r\n  color: #0080ff;\r\n  margin-top: 5px;\r\n}\r\n\r\n.input-phone {\r\n  font-family: 'Bezier Sans';\r\n  width: 100%;\r\n  height: 48.2px;\r\n  border: 1px solid black;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  border-radius: 15px;\r\n}\r\n\r\n.contact-button {\r\n  width: 622px;\r\n  height: 38px;\r\n  background-color: #0080ff;\r\n  border-radius: 15px;\r\n  border: 1px solid #0014ff;\r\n  font-family: 'Bezier Sans';\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: white;\r\n  cursor: pointer;\r\n  margin: 20px auto 0; /* Center horizontally and add top margin */\r\n  transition: background-color 0.3s, color 0.3s;\r\n  align-self: center; /* Center within flex container */\r\n}\r\n\r\n.contact-button:hover {\r\n  background-color: #ffffff;\r\n  color: black;\r\n}\r\n\r\n.data-admin-note {\r\n  font-family: 'Bezier Sans';\r\n  font-size: 12px;\r\n  color: #0080ff;\r\n  margin-top: 20px;\r\n  text-align: center;\r\n  width: 100%; /* Ensure it takes full width */\r\n  display: flex;\r\n  justify-content: center; /* Center horizontally */\r\n  padding-bottom: 20%;\r\n}\r\n\r\n.feedback {\r\n  color: #0014ff;\r\n  justify-content: center;\r\n  align-self: center;\r\n}\r\n\r\n.horizontal-container .input-container:first-child {\r\n  margin-right: 20px; /* Adjust the value as needed */\r\n}\r\n\r\n.error {\r\n  border-color: red; /* Цвет границы для полей с ошибками */\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  font-size: 12px;\r\n  margin-top: 5px;\r\n}\r\n\r\n\r\n\r\n/* Mobile styles */\r\n@media (max-width: 768px) {\r\n  .form-container {\r\n    width: 100%;\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .label {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .horizontal-container {\r\n    flex-direction: column; /* Stack vertically on mobile */\r\n    align-items: flex-start; /* Align items to the start */\r\n  }\r\n\r\n  .input-container {\r\n    width: 100%; /* Full width for input containers */\r\n    padding: 0;\r\n    margin-bottom: 15px; /* Add more spacing between inputs */\r\n  }\r\n\r\n  .text-window,\r\n  .email-window,\r\n  .input-phone {\r\n    margin-left: 10px;\r\n    width: 85%; /* Ensure phone input is the same width as other inputs */\r\n    height: 48px; /* Increase height for better touch experience */\r\n  }\r\n\r\n  .phone-input-container {\r\n    width: 100%; /* Ensure full width for the container */\r\n  }\r\n\r\n  .phone-input-container input {\r\n    height: 48px; /* Match the height of other inputs */\r\n  }\r\n\r\n  .contact-button {\r\n    width: 80%; /* Full width for the button */\r\n    height: 48px; /* Increase button height */\r\n  }\r\n\r\n  .message-window {\r\n    height: 150px; /* Increased height for mobile */\r\n  }\r\n\r\n  .data-admin-note {\r\n    align-items: center;\r\n    width: 80%;\r\n    padding-left: 5%;\r\n    padding-bottom: 150px; /* Increase padding for better spacing */\r\n  }\r\n\r\n  .elementstyle {\r\n    width: 80%;\r\n  }\r\n\r\n  .input-phone {\r\n    margin-left: 10px;\r\n    width: 85%; \r\n     /* Ensure full width inside the reduced container */\r\n  }\r\n  .necessary-note {\r\n    padding-left: 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
